module.exports = __webpack_public_path__ + "static/fonts/youshe.1726685c.ttf";